import { MAX_LEVEL, MAX_TYPE_COUNT, MIN_TYPE_COUNT } from "./model";

export function triangular(n: number): number {
  if (n <= 0) {
    return 0;
  }
  return (n * (n + 1)) / 2;
}

export function scoreForWave(level: number, erased: number, chain: number): number {
  return 500 + level * 50 + triangular(erased - 4) + chain * chain;
}

export function activeTypeCount(level: number): number {
  return Math.max(MIN_TYPE_COUNT, Math.min(MAX_TYPE_COUNT, MIN_TYPE_COUNT + Math.floor((level - 1) / 10)));
}

export function fallTicksForLevel(level: number): number {
  return 32 - ((level - 1) % 10) * 3;
}

export function fallIntervalMs(level: number): number {
  return fallTicksForLevel(level) * 30;
}

export interface LevelProgressResult {
  level: number;
  progress: number;
  levelUps: number;
}

export function applyErasedToLevel(level: number, progress: number, erased: number): LevelProgressResult {
  let nextLevel = Math.max(1, Math.min(MAX_LEVEL, Math.floor(level)));
  let nextProgress = Math.max(0, Math.floor(progress)) + Math.max(0, Math.floor(erased));
  let levelUps = 0;

  while (nextProgress >= 10 && nextLevel < MAX_LEVEL) {
    nextProgress -= 10;
    nextLevel += 1;
    levelUps += 1;
  }

  if (nextLevel >= MAX_LEVEL) {
    nextProgress = Math.min(nextProgress, 9);
  }

  return { level: nextLevel, progress: nextProgress, levelUps };
}
